<template>
  <div
    class="modal__cover text-image-modal--with-secondary"
    @click.self="onClickModalCover"
  >
    <div class="modal__content">
      <div class="modal__image">
        <ImgLazy
          :image-url="imageUrl"
          :alt-text="imageAltText"
          :aspect-ratio="imageAspectRatio"
        />
      </div>
      <div class="modal__descriptions">
        <div class="modal__text">
          <div class="modal__text__title">
            <span>{{ titleText }}</span>
          </div>
          <div class="modal__text__caption">
            <span>{{ captionText }}</span>
          </div>
        </div>
        <div class="modal__btn">
          <div class="modal__btn--primary">
            <button
              type="button"
              class="btn btn--primary"
              @click="onClickPrimaryButton"
            >
              {{ primaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--secondary">
            <button
              type="button"
              class="btn btn--secondary"
              @click="onClickSecondaryButton"
            >
              {{ secondaryButtonText }}
            </button>
          </div>
          <div class="modal__btn--cancel">
            <span @click="onClickCancelButton">{{ cancelButtonText }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImgLazy from '../../../atoms/images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    imageAltText: {
      type: String,
      required: false,
      default: 'モーダル画像'
    },
    imageAspectRatio: {
      type: String,
      required: true,
      default: '1'
    },
    titleText: {
      type: String,
      required: true
    },
    captionText: {
      type: String,
      required: true
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    secondaryButtonText: {
      type: String,
      required: true
    },
    cancelButtonText: {
      type: String,
      required: true
    }
  },
  methods: {
    onClickModalCover() {
      this.$emit('clicked-modal-cover')
    },
    onClickPrimaryButton() {
      this.$emit('clicked-primary')
    },
    onClickSecondaryButton() {
      this.$emit('clicked-secondary')
    },
    onClickCancelButton() {
      this.$emit('clicked-cancel')
    }
  }
}
</script>
